import React, { useContext, useState } from "react";
import InsideLayout from "../../layout/inside_main_layout";
import GeneralTab from "./Tabs/GeneralTab/GeneralTab";
import { ConfirmProvider } from "material-ui-confirm";
import { TabTitle, TabPanels } from "../../components/tabs/TabsTabPanelsComponent";
import AuthenticationTab from "./Tabs/AuthenticationTab/AuthenticationTab";
import { AppConfig } from "../../context/context";


const OrgSettings = () => {
  const [showLeavePrompt, setShowLeavePrompt] = useState<boolean>(false);
  const { availableFeatures } = useContext(AppConfig);
  const defaultTabs : string[] = ["General", "Authentication"];
  const [tabLabels, setLabels] = useState<string[]>(defaultTabs);
  const [selectedTab, setSelectedTab] = useState<number>(0);

  return (
      <InsideLayout title = "page_settings_title">            
        <ConfirmProvider>
          <TabTitle tabLabels={tabLabels} 
              showLeavePrompt={showLeavePrompt} 
              setShowLeavePrompt={setShowLeavePrompt}
              setValue = {setSelectedTab}
              value = {selectedTab}
          />
          <TabPanels value={selectedTab}>
            <GeneralTab setShowLeavePrompt={setShowLeavePrompt}/>
            <AuthenticationTab setShowLeavePrompt = {setShowLeavePrompt} /> 
          </TabPanels>
        </ConfirmProvider>      
      </InsideLayout>
  );
};

export default OrgSettings;
